const actionTypeIdentifier = "9299A6CA-DF9F-422C-B377-23673CD4AF64";

export const getInventoryHandlerList = `GET-INVENTORY-HANDLER-LIST${actionTypeIdentifier}`;
export const setInventoryUploadError = `SET-INVENTORY-UPLOAD-ERROR${actionTypeIdentifier}`;
export const getInventoryHandlerUploadTypeList = `GET-INVENTORY-HANDLER-UPLOAD-TYPE-LIST${actionTypeIdentifier}`;

export const InventoryUploadModel = {
    inventoryHandlerId: 0,
    inventoryHandlerUploadTypeId: 0,
    files: []
}